$(document).ready(function() {
  // product page accordion (i.e. Ingredients)
  $('.accordion-title').click(function(){
    $(this).next('.accordion-panel').slideToggle();
    $(this).find('.arrow').toggleClass('arrow-down');
  });
  
  // size chart pop-up
  $('.product-single__size-chart-link').click(function() {
    $('.product-single__size-chart-modal').addClass('on');
    $('.product-single__size-chart-full-screen').addClass('on');
  });
  
  $('.product-single__size-chart-modal').click(function() {
    $('.product-single__size-chart-modal').removeClass('on');
    $('.product-single__size-chart-full-screen').removeClass('on');
  });
  
  $('.product-single__size-chart-full-screen').click(function() {
    $('.product-single__size-chart-modal').removeClass('on');
    $('.product-single__size-chart-full-screen').removeClass('on');
  });
  
  //
  // custom 'add name/number' product pages
  //
  
  if ( $('.product-form__add-custom-product').length > 0 ) {
    
    var currentProdHandle = $('.product-form__add-custom-product').attr('data-main-handle');  
    var currentVarID = $('.product-form__variants option:selected').val();
    
    var currentPrice;
    var onSale;
    $.getJSON('/products/' + currentProdHandle + '.js', function(product) {
      // get the currently selected variant, and find the price. add (or remove) the price of the additional product to the product page price
      $(product.variants).each(function(i) {
        if ( this.id == currentVarID ) {
          
          currentPrice = this.price;
          
          if ( this.compare_at_price > this.price ) {
            onSale = true;
            $('.price-item--sale').html(Shopify.formatMoney(currentPrice));
          } else {
            onSale = false;
            $('.price-item--regular').html(Shopify.formatMoney(currentPrice));
          }
          
        }
      });
    });
  

    var productAdded = false;
    var productTwoAdded = false;
    
  
    $('.single-option-selector').change(function() {
      currentVarID = $('.product-form__variants option:selected').val();
      console.log(currentVarID);
    });
    
    $('.product-form__add-custom-product .btn.show').click(function() {

      var addPrice = parseInt($('.product-form__add-custom-product').attr('data-price'));
      if ( productAdded == false ) {
        productAdded = true;
        currentPrice += addPrice;
      } else {
        productAdded = false
        currentPrice -= addPrice;
      }

      if ( onSale ) {
        $('.price-item--sale').html(Shopify.formatMoney(currentPrice));
      } else {
        $('.price-item--regular').html(Shopify.formatMoney(currentPrice));
      }


      $('.product-form__add-custom-product .btn.show .toggle').toggleText('Add', 'Remove');
      $('.product-form__add-custom-product .btn.show .add-price').toggleText('+', '-');
      $('.custom-attributes').toggle();

      currentVarID = $('.product-form__variants option:selected').val();

    });

    $('.product-form__add-custom-product-2 .btn.show_2').click(function() {

      var addPrice2 = parseInt($('.product-form__add-custom-product-2').attr('data-price'));

      if ( productTwoAdded == false ) {
        productTwoAdded = true;
        currentPrice += addPrice2;
      } else {
        productTwoAdded = false
        currentPrice -= addPrice2;

      }

	  if ( onSale ) {
        $('.price-item--sale').html(Shopify.formatMoney(currentPrice));
      } else {
        $('.price-item--regular').html(Shopify.formatMoney(currentPrice));
      }

      $('.product-form__add-custom-product-2 .btn.show_2 .toggle').toggleText('Add', 'Remove');
      $('.product-form__add-custom-product-2 .btn.show_2 .add-price').toggleText('+', '-');
      $('.custom-attributes_2').toggle();

      $('.variant-select-imgs img').click(function() {
        $('.variant-select-imgs img').removeClass('active');
        $(this).addClass('active');
        $('.custom-attributes_2 .current-selected-var').html($(this).attr('alt'));
      });

    });
  } 
  
  
  $.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
  });
  
  // CUSTOM ADD TO CART with Shopify queue
  Shopify.queue = [];
  Shopify.moveAlong = function() {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    }
    else {
      document.location.href = '/cart';
    }
  };
  Shopify.addItem = function(id, qty, properties, callback) {
    var params = {
      quantity: qty,
      id: id
    };
    if(properties != false){
      params.properties = properties;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: params,
      success: function(){
        if(typeof callback === 'function'){
          callback();
        }
      },
      error: function(){}
    });
  }
  function push_to_queue(variantID, quantity, properties,callback) {
    Shopify.queue.push({
      variantId: variantID,
      quantity: quantity,
      properties: properties
    });
     if(typeof callback === 'function'){
          callback();
     }
  }
  
  $('.btn.custom-add-to-cart').click(function(e) {
    // prevent add to cart action
    e.preventDefault();
    
    // don't let double click happen
    $(this).html('Added');
    $(this).addClass('inactive');
    
    var addVarID = $('.custom-variant-selection option:selected').attr('data-var-id');
    var addVarID2 = $('.variant-select-imgs img.active').attr('data-var-id');
    var mainQuantity = parseInt($('.product-form__item--quantity').val(), 10) || 0;
    var mainProps;
    var productName = $(".btn.show").attr("data-product").toString();
    
    // add the additional product to the queue if selected. add name/number as cart attributes
    if ( productAdded ) {
      mainProps = {
        [$(".btn.show").attr("data-product")] : 'Yes'
      }
      
      var addProps = {
        [$('.prop-1-label').html()] : $('.prop-1').val(),
        [$('.prop-2-label').html()] : $('.prop-2').val()
      }
      
      push_to_queue(parseInt(addVarID), 1, addProps);
    } else {
      mainProps = {
        [$(".btn.show").attr("data-product")] : 'No'
      }
    } 
    
    // add the additional product to the queue if selected. add name/number as cart attributes
    if ( productTwoAdded ) {
      Object.assign(mainProps, {Logo: 'Yes'});
      push_to_queue(parseInt(addVarID2), 1);
    } else {
      Object.assign(mainProps, {Logo: 'No'});
    }
    
    if ( $('.product-form__length select').val() == 'Cropped') {

      Object.assign(mainProps, {Length: 'Cropped'});
    } else {
      Object.assign(mainProps, {Length: 'Full Length'});
    }
    
    // add the main product to the queue
    push_to_queue(parseInt(currentVarID), 1, mainProps);
      
    
    Shopify.moveAlong();
  });
  
  
});